import React from "react";

const options_default = {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
};

const DateDisplay = (props) => {
    const { options = options_default } = props;
    return <>{new Date(props.children).toLocaleDateString("en-IN", options)}</>;
};

export default DateDisplay;
